const normalize = (value) => String(value || '').trim()

export const normalizeBankTransferDetails = (source = {}) => {
  const details = {
    beneficiary: normalize(source.beneficiary),
    iban: normalize(source.iban).replace(/\s+/g, ''),
    bank_name: normalize(source.bank_name),
    reference_label: normalize(source.reference_label) || 'Numar comanda',
    reference_value: normalize(source.reference_value),
    configured: false
  }

  details.configured = [
    details.beneficiary,
    details.iban,
    details.bank_name,
    details.reference_label
  ].every(Boolean)

  return details
}

export const getBankTransferDetailsFromOrder = (order) => (
  normalizeBankTransferDetails(order?.seller_snapshot?.bank_transfer || {})
)

export const getBankTransferDetailsFromSettings = (settingsState) => (
  normalizeBankTransferDetails(
    settingsState?.paymentMethods?.bank_transfer ||
    settingsState?.payment_methods?.bank_transfer ||
    {}
  )
)
